import { useMemo } from 'react';
import ProductsDetailsActions from './ProductsDetailsActions';
import ProductTable from './ProductTable';

const ProductsDetails = ({
  detailsRef,
  orderNumber,
  items,
  customer,
  orderStatus,
  orderUUID,
  fetchOrderDetail,
}) => {
  const activeSkusQuantities = useMemo(
    () =>
      items?.length
        ? items.reduce((total, item) => total + (item.quantity > 0 ? 1 : 0), 0)
        : 0,
    [items],
  );

  return (
    <div>
      <div className="row border-top pt-4">
        <div className="col-12">
          <h1 className="mt-2 fw-light" ref={detailsRef}>
            Detalhes do pedido{' '}
            {activeSkusQuantities ? `(${activeSkusQuantities})` : '(-)'}
          </h1>
        </div>
      </div>

      <div className="row">{items && <ProductTable items={items} />}</div>

      <ProductsDetailsActions
        customer={customer}
        orderStatus={orderStatus}
        orderNumber={orderNumber}
        orderUUID={orderUUID}
        fetchOrderDetail={fetchOrderDetail}
      />
    </div>
  );
};

export default ProductsDetails;
